<template>
    <div>
        <button type="button" class="button small black-outline" @click="onGoto(1)">1111</button>
        <button type="button" class="button small black-outline" @click="onGoto(2)">2222</button>
        <button type="button" class="button small black-outline" @click="onGoto(3)">3333</button>
        <button type="button" class="button small black-outline" @click="onGoto(4)">4444</button>
        <hr />
        <hr />
        <hr />
        <h1>testp_1</h1>
        <CusSelect :li-list="liList" @onReturn="onSelected" />
        CusSelect selected : {{ selected }}
        <hr />
        <CusCheck :label="가나다" :checked="true" @onReturn="onChecked" />
        <hr />
        <p class="input__field">
            <input type="radio" name="radio" id="radio" class="radio__input" />
            <label for="radio" class="radio__label">전체</label>
            <input type="radio" name="radio" id="radio1" class="radio__input" />
            <label for="radio1" class="radio__label">라디오오</label>
            <input type="radio" name="radio" id="disabled" class="radio__input" disabled />
            <label for="disabled" class="radio__label">라디오오오오오</label>
        </p>
        <hr />
        <CusToggle :is-checked="true" @onReturn="onToggle" />
        <hr />
        <div class="subpage">
            <div class="subpage__inner">
                <div class="title__content flex justify-between">
                    <h2 class="title">내위치</h2>
                    <button type="button" class="button small black-outline">작품별 보기</button>
                    <!-- <button type="button" class="button small primary">학습 기록 보기</button> -->
                </div>
            </div>
        </div>

        <hr />
        <div>
            <p class="h3">button</p>
            <p class="h4">base size</p>
            <CusButton :type="100" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="120" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="140" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="160" :label="btnTitle_test" @onReturn="onBtnClick" />
            <hr />
            <p class="h4">disabled</p>
            <CusButton :type="180" :label="btnTitle_test" @onReturn="onBtnClick" />
            <hr />
            <p class="h4">100% full size</p>
            <CusButton :type="200" :label="btnTitle_test" @onReturn="onBtnClick" />
            <hr />
            <p class="h4">round</p>
            <CusButton :type="300" :label="btnTitle_test" @onReturn="onBtnClick" />
            <hr />
            <p class="h4">color</p>
            <CusButton :type="400" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="410" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="420" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="430" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="440" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="450" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="460" :label="btnTitle_test" @onReturn="onBtnClick" />
            <hr />
            <p class="h4">fixed size 기준 해상도 2000x1200(반응형)</p>
            <p class="b2">login (w=600px)</p>
            <CusButton :type="500" :label="btnTitle_test" @onReturn="onBtnClick" />
            <p class="b2">report (w=396px)</p>
            <CusButton :type="550" :label="btnTitle_test" @onReturn="onBtnClick" />
            <hr />
            <p class="h4">prev, next</p>
            <CusButton :type="310" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="320" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="330" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="340" :label="btnTitle_test" @onReturn="onBtnClick" />
            <hr />
            <p class="h4">맞춤 학습 완료 버튼</p>
            <CusButton :type="350" :label="btnTitle_test" @onReturn="onBtnClick" />
            <hr />
            <p class="h4">맞춤 학습 o/x 버튼</p>
            <CusButton :type="360" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="370" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="380" :label="btnTitle_test" @onReturn="onBtnClick" />
            <CusButton :type="390" :label="btnTitle_test" @onReturn="onBtnClick" />
        </div>

        <hr />
        <CusToast :type="100" :msg="toastMsg" @onReturn="onBtnClick" />
        <CusToast :type="200" :msg="toastMsg" @onReturn="onBtnClick" />
        <CusToast :type="300" :msg="toastMsg" @onReturn="onBtnClick" />
        <CusToast :type="400" :msg="toastMsg" @onReturn="onBtnClick" />
        <CusToolTip :type="500" :msg="toastMsg" @onReturn="onBtnClick" />
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import CusSelect from '@/components/widget/CusSelect.vue';
import CusCheck from '@/components/widget/CusCheck.vue';
import CusToggle from '@/components/widget/CusToggle.vue';
import CusButton from '@/components/widget/CusButton.vue';
import CusToast from '@/components/widget/CusToast.vue';
import CusToolTip from '@/components/widget/CusToolTip.vue';
import { useRouter } from 'vue-router';
// import { GlobalStore } from '@/store';
// import { DialogStore } from '@/store/modules/dialog';
const router = useRouter();
// const gStore = GlobalStore();
// const dStore = DialogStore();
const toastMsg = ref(
    '토스트 메세지입니다. 테스트중입니다.토스트 메세지입니다. 테스트중입니다.토스트 메세지입니다. 테스트중입니다.토스트 메세지입니다. 테스트중입니다.토스트 메세지입니다. 테스트중입니다.토스트 메세지입니다. 테스트중입니다.토스트 메세지입니다. 테스트중입니다.',
);

const liList = ref(['전체', '3일', '7일']);
const selected = ref('전체');
const btnTitle_test = ref('btnTitle_Test');

const onGoto = (index) => {
    const whereToGo = '/testp' + index;
    router.push(whereToGo);
};
const onSelected = (index) => {
    selected.value = liList.value[index];
};
const onChecked = (bool) => {
    // console.log(' tttestPP onChecked : start', bool);
};
const onToggle = (bool) => {
    // console.log(' tttestPP onToggle : start', bool);
};
const onBtnClick = () => {
    // console.log(' tttestPP onBtnClick');
};
onMounted(() => {});
</script>

<style scoped lang="scss"></style>
